const commonSteps = (contractType) => [
    { name: 'Conditions', target: `conditions/${contractType}` },
    { name: 'Souscription', target: `overview/${contractType}` },
    { name: 'Informations', target: `informations/${contractType}` },
];

const targetSteps = (contractType) => [
    { name: 'Docs internes', target: `internalDocs/${contractType}` },
    { name: 'Signature', target: `signatures/${contractType}` },
    { name: 'Extranet', target: `perHub/${contractType}` },
];

const getWizard = (contractType) => ({
    prefixTemplate: ({ id, contractId }) => `/rip/${id}/contracts/${contractId}`,
    items: [
        ...commonSteps(contractType),
        ...(targetSteps(contractType)),
    ],
});

export default getWizard;
